// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"loading_spinnerContainer__3Rsv8","spinner":"loading_spinner__M9sfO"};